/** Unpublish in the Editor (release Plan 5). The server owns the rules; this is the copy and the outcome. */
export const UNPUBLISH_CONFIRM =
  'Unpublish takes your live app offline on the web and on phones. Your address stays reserved for this project, and publishing again brings it back.';

export const UNPUBLISHED_NOTE =
  'Unpublished. Visitors now see "This app is not available right now." Publish again to bring it back at the same address.';

export type UnpublishOutcome = 'done' | 'needs-name' | 'error';

/** The server answers 409 + confirmRequired when the app has end users: then the owner types the project name. */
export function unpublishOutcome(r: { ok: boolean; confirmRequired?: boolean }): UnpublishOutcome {
  if (r.ok) return 'done';
  return r.confirmRequired ? 'needs-name' : 'error';
}
